import Ajv, { ErrorObject } from 'ajv';
import AjvErrors from 'ajv-errors';

interface ExtendedErrorObject<
  K extends string = string,
  P = Record<string, any>,
  S = unknown,
> extends ErrorObject<K, P, S> {
  dataPath: string;
}

class SchemaHelper {
  private errors: ExtendedErrorObject<string, Record<string, any>, unknown>[];
  public constructor() {
    this.errors = [];
  }
  public validate(inputData: any, schema: any): boolean {
    const ajv = new Ajv({
      allErrors: true,
      verbose: true,
      strict: 'log',
      code: { es5: true },
      unicodeRegExp: false,
    });
    AjvErrors(ajv);
    const validate = ajv.compile(schema);
    let isValid;
    try {
      isValid = validate(inputData);
    } catch (e) {}

    this.errors = (validate.errors || []) as ExtendedErrorObject<
      string,
      Record<string, any>,
      unknown
    >[];

    if (!isValid) {
      console.error(
        '%c JSON Schema Validation failed:',
        'background: #222; color: #bada55',
        validate.errors,
      );
    }

    return isValid ? true : false;
  }
  public flatSchema(schema: any) {
    return {
      ...schema,
      properties: Object.keys(schema.properties).reduce((acc, key: any) => {
        acc = { ...acc, [key]: { type: 'string' } };

        return acc;
      }, {}),
    };
  }

  public getErrors() {
    console.error(
      '%c JSON Schema Validation failed:',
      'background: #222; color: blue',
      this.errors,
    );

    return this.errors;
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new SchemaHelper();
